import { Text } from '@mantine/core';
import { BackButton } from 'components/shared';
import { Fragment } from 'react';
import { useNavigate } from 'react-router';
import { useCreateIntegration } from 'utils/integrations';
import IntegrationForm from 'components/IntegrationsDashboard/IntegrationForm';

const AddIntegration = () => {
  const [addIntegration] = useCreateIntegration();
  const navigate = useNavigate();
  return (
    <Fragment>
      <BackButton onClick={() => navigate('/api/list')}>{'<'} Back to all APIs</BackButton>
      <IntegrationForm action="CREATE" onSubmit={api => addIntegration({ variables: { api } })} />
    </Fragment>
  );
};

export default AddIntegration;
